import React from 'react';
import {useFieldArray, useForm} from 'react-hook-form';
import {z} from 'zod';
import {zodResolver} from '@hookform/resolvers/zod';
import {Form} from '@src/@/components/ui/form';
import {PaypalIcon} from "@pages/merchant/onboarding/components/PayPal.icon";
import {SepaIcon} from "@pages/merchant/onboarding/components/SepaIcon";
import {IDealIcon} from "@pages/merchant/onboarding/components/IDealIcon";
import {PaymentMethodField} from "@pages/merchant/onboarding/forms/subscription/PaymentMethod.field";
import {VatRateField} from "@pages/merchant/onboarding/forms/subscription/VatRate.field";
import {InputField} from "@pages/merchant/onboarding/forms/subscription/Input.field";

export const availablePaymentMethods = [
    {
        name: 'SEPA',
        icon: <SepaIcon/>
    },
    {
        name: 'iDEAL',
        icon: <IDealIcon/>
    },
    {name: 'Credit Card', icon: ''},
    {
        name: 'PayPal',
        icon: <PaypalIcon/>
    },
    {name: 'Others', icon: ''},
];


const paymentMethodSchema = z.object({
    methodName: z.string().min(1),
    feeType: z.string().min(1),
    feeAmount: z.string().min(1),
});

const formSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().min(1, 'Description is required'),
    VATRate: z.string().min(1, 'VATRate is required'),
    paymentMethods: z.array(paymentMethodSchema).min(1, 'Choose at least one (1) Payment method'),
});

export type FormSchema = z.infer<typeof formSchema>;

const SubscriptionPulloverCreateForm = () => {
    const form = useForm<FormSchema>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            title: '',
            description: '',
            VATRate: '',
        }
    });

    const {errors} = form.formState

    const {fields, append, remove} = useFieldArray({
        control: form.control,
        name: 'paymentMethods',
    });

    const handleCheckboxChange = (method: string) => {
        const methodIndex = fields.findIndex((field) => field.methodName === method);

        if (methodIndex !== -1) {
            remove(methodIndex);
        } else {
            const selectedMethod = availablePaymentMethods.find(item => item.name === method);
            if (selectedMethod) {
                append({methodName: method, feeType: '', feeAmount: ''});
            }
        }
    };


    return (
        <>
            <Form {...form}>
                <form
                    className='h-full flex flex-col space-y-2 overflow-y-auto'>
                    {
                        ['title', 'description'].map((name, index) => {
                            return (
                                <InputField key={index} name={name} errors={errors}/>
                            )
                        })
                    }
                    <VatRateField errors={errors}/>
                    <PaymentMethodField fields={fields} form={form}
                        handleCheckboxChange={handleCheckboxChange} errors={errors}/>
                </form>
            </Form>
        </>
    );
}
export default SubscriptionPulloverCreateForm;